<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.experienceComment')"
    :batch-actions="batchActions"
    resource="experience_comments"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/experience_comments.js';
import { columnsExtend as commentableCommentDatumColumnsExtend } from '../admin_entities/commentable_comment_datum_detail.js';
import _ from 'lodash';

@Component
export default class ExperienceComments extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'content_cont',
      {
        key: 'commentable_id_eq',
        label: this.$t('experienceComment.commentable'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/posts/read_options', { per_page: 100, type_eq: 'BookClub' });
              return data.map(item => ({ value: item.id, label: item.title }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/posts/read_options', { keyword, type_eq: 'BookClub' });
              return data.map(item => ({ value: item.id, label: item.title }));
            }
          }
        }
      },
      'deleted_at_not_null',
      'position_not_null',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const [commentsCount] = commentableCommentDatumColumnsExtend(['comments_count'])
    const array = [
      type === 'show' && 'id',
      type === 'index' && {
        key: 'content',
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          const length = 40

          if (value.length <= length) {
            return <span>{value}</span>
          } else {
            return <span>{`${value.substring(0, length)}...`}</span>
          }
        }
      },
      type === 'show' && 'content',
      'creator',
      'commentable',
      'likes_count',
      { ...commentsCount, prop: 'commentable_comment_datum.comments_count' },
      'is_top',
      'is_deleted',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: '查看评论',
          to: { name: 'normal_comments.index', query: { commentable_of_any_type_type_eq: row.commentable_type, commentable_id_eq: row.id } }
        }
      },
      !row.is_top && {
        component: 'confirmButton',
        props: {
          label: '置顶',
          type: 'primary',
          can: 'experience_comments.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/comments/${row.id}/position_to_minimum`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.is_top && {
        component: 'confirmButton',
        props: {
          label: '取消置顶',
          type: 'primary',
          can: 'experience_comments.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/comments/${row.id}/position_to_nil`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_deleted && {
        component: 'confirmButton',
        props: {
          label: '隐藏',
          type: 'primary',
          can: 'experience_comments.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/comments/${row.id}/hide`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.is_deleted && {
        component: 'confirmButton',
        props: {
          label: '显示',
          type: 'primary',
          can: 'experience_comments.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/comments/${row.id}/show`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'experience_comments.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/experience_comments',
    name: 'experience_comments.index',
    component: ExperienceComments,
    props: {
      type: 'index',
    }
  },
  {
    path: '/experience_comments/new',
    name: 'experience_comments.new',
    component: ExperienceComments,
    props: {
      type: 'new',
    }
  },
  {
    path: '/experience_comments/:id',
    name: 'experience_comments.show',
    component: ExperienceComments,
    props: {
      type: 'show',
    }
  },
  {
    path: '/experience_comments/:id/edit',
    name: 'experience_comments.edit',
    component: ExperienceComments,
    props: {
      type: 'edit'
    }
  }
]
</script>
